import { render, staticRenderFns } from "./ScoringAnswerList.vue?vue&type=template&id=21365403"
import script from "./ScoringAnswerList.vue?vue&type=script&lang=js"
export * from "./ScoringAnswerList.vue?vue&type=script&lang=js"
import style0 from "./ScoringAnswerList.vue?vue&type=style&index=0&id=21365403&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@1.0.1_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports